import { Ref } from 'vue';
import { useQuery } from '@tanstack/vue-query';
import { AxiosError, AxiosResponse } from 'axios';

import { api } from './_http';

type GetMajorHolderNameResType = {
	major_holder_name: MajorHolderNameType[];
};

export type MajorHolderNameType = {
	major_holder_event_pk: number;
	major_holder_name: string;
	image_path: string;
};

export const useGetMajorHolderNameApi = (options?: any) => {
	const url = '/v1/front/usa/getMajorHolderName';
	return useQuery<AxiosResponse, AxiosError, GetMajorHolderNameResType>({
		queryKey: [url],
		queryFn: () => api.get(url),
		select: (res) => {
			return res.data?.data;
		},
		...options,
	});
};

type GetMarketTimingParams = {
	major_holder_event_pk: string;
};

export type EventList = {
	event_list_pk: number;
	major_holder_event_pk: number;
	event_list_category: string;
	event_pk: string;
	event_name: string;
	event_ticker: string;
	event_list_proportion: string;
	event_list_proportion_change: string;
	event_list_enrollment_date: string;
	major_holder_proportion_name: string;
	major_holder_proportion_ticker: string;
	major_holder_proportion: string;
	major_holder_proportion_change: string;
	file_path: string;
	bookmark: boolean;
};

type MajorHolderEventList = {
	excel_path: string;
	excel_pk: number;
	image_path: string;
	image_pk: number;
	major_holder_base_date: string;
	major_holder_enrollment_date: string;
	major_holder_event_pk: number;
	major_holder_name: string;
	major_holder_newly_date: string;
	major_holder_selling_date: string;
	major_holder_seq: number;
};
export type GetMajorHolderEventResType = {
	major_holder_event: MajorHolderEventList[];
	major_holder_proportion: EventList[]; // Assuming it's empty or unspecified, you may specify it more if needed
	major_holder_newly_added: EventList[];
	major_holder_selling: EventList[];
};
export const useGetMajorHolderEventApi = (params: Ref<GetMarketTimingParams>, options?: any) => {
	const url = '/v1/front/usa/getMajorHolderEvent';
	return useQuery<AxiosResponse, AxiosError, GetMajorHolderEventResType>({
		queryKey: [url, params],
		queryFn: () => api.get(url, params.value),
		select: (res) => {
			return res.data?.data;
		},
		...options,
	});
};
